/**
 * PSL Fire & Safety - Black Friday Part One Countdown & Interactive Handlers
 * Target: Friday, November 27, 2026 00:00:00 NZDT (UTC+13)
 */
(function () {
  function initBlackFriday() {
    var root = document.querySelector('.psl-bf-root') || document.querySelector('.black-friday-page-wrapper');
    if (!root) return;

    // 1. COUNTDOWN TIMER TO FRIDAY, NOVEMBER 27, 2026 00:00:00 NZDT
    var targetDate = new Date('2026-11-27T00:00:00+13:00').getTime();

    function updateTimer() {
      var now = new Date().getTime();
      var diff = targetDate - now;

      var dEl = document.getElementById('psl-bf-d') || document.getElementById('bf-days');
      var hEl = document.getElementById('psl-bf-h') || document.getElementById('bf-hours');
      var mEl = document.getElementById('psl-bf-m') || document.getElementById('bf-minutes');
      var sEl = document.getElementById('psl-bf-s') || document.getElementById('bf-seconds');

      if (!dEl || !hEl || !mEl || !sEl) return;

      if (diff > 0) {
        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var mins = Math.floor((diff % (1000 * 60)) / (1000 * 60));
        var secs = Math.floor((diff % (1000 * 60)) / 1000);

        dEl.textContent = days < 10 ? '0' + days : days;
        hEl.textContent = hours < 10 ? '0' + hours : hours;
        mEl.textContent = mins < 10 ? '0' + mins : mins;
        sEl.textContent = secs < 10 ? '0' + secs : secs;
      } else {
        dEl.textContent = '00';
        hEl.textContent = '00';
        mEl.textContent = '00';
        sEl.textContent = '00';
      }
    }

    updateTimer();
    setInterval(updateTimer, 1000);

    // 2. QUANTITY & DIRECT CHECKOUT UPDATER
    var BF_UNIT_PRICE = 43.20;
    var BF_ORIG_PRICE = 72.00;
    var VARIANT_ID = '44990244356279';
    var DISCOUNT = 'BF40';
    var qty = 1;

    function setQty(newQty) {
      qty = Math.max(1, Math.min(5, newQty));
      var input = document.getElementById('psl-bf-qty-val');
      if (input) input.value = qty;

      var totalSale = (BF_UNIT_PRICE * qty).toFixed(2);
      var totalOrig = (BF_ORIG_PRICE * qty).toFixed(2);

      var saleDisplay = document.getElementById('psl-bf-sale-display');
      var origDisplay = document.getElementById('psl-bf-orig-display');
      var btnTotal = document.getElementById('psl-bf-btn-total');
      var checkoutLink = document.getElementById('psl-bf-checkout-link') || document.getElementById('bf-main-checkout-btn');

      if (saleDisplay) saleDisplay.textContent = '$' + totalSale + ' NZD';
      if (origDisplay) origDisplay.textContent = '$' + totalOrig + ' NZD';
      if (btnTotal) btnTotal.textContent = '$' + totalSale;
      if (checkoutLink) {
        checkoutLink.href = 'https://www.pslfireandsafety.co.nz/cart/' + VARIANT_ID + ':' + qty + '?checkout&discount=' + DISCOUNT;
      }
    }

    // 3. EVENT DELEGATION: Robust click handler (works even if Shopify strips inline onclick attributes)
    document.addEventListener('click', function (e) {
      // Quantity Buttons
      var qtyBtn = e.target.closest('.psl-bf-qty-btn');
      if (qtyBtn) {
        e.preventDefault();
        var txt = qtyBtn.textContent.trim();
        if (txt === '-' || txt === '−') {
          setQty(qty - 1);
        } else if (txt === '+') {
          setQty(qty + 1);
        }
        return;
      }

      // Thumbnail Image Switcher
      var thumb = e.target.closest('.psl-bf-thumb') || e.target.closest('.bf-thumb');
      if (thumb) {
        var img = thumb.querySelector('img');
        if (img) {
          var mainImg = document.getElementById('psl-active-bf-img') || document.getElementById('bf-active-image');
          if (mainImg) mainImg.src = img.src;

          var allThumbs = document.querySelectorAll('.psl-bf-thumb, .bf-thumb');
          allThumbs.forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
        }
      }
    });

    console.log('[PSL Black Friday] Timer active. Counting down to Friday, November 27, 2026 NZDT.');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlackFriday);
  } else {
    initBlackFriday();
  }
})();

